import { Reveal, Eyebrow } from "../components/Reveal";
import Estimator from "../components/Estimator";
import PricingTables from "../components/PricingTables";
import CTASection from "../components/CTASection";
import { Seo } from "../components/Seo";

const Pricing = () => (
    <main className="bg-brand-ink">
        <Seo
            title="Stump Grinding Prices"
            description="Stump grinding prices in Poplar Bluff, MO: $150 for stumps up to 15 inches, $185 for 20 inches, up to $535 for 70 inches. Difficulty add-ons and cleanup options listed upfront. Instant estimate tool."
        />
        <section className="max-w-7xl mx-auto px-5 sm:px-8 pt-40 pb-16">
            <Reveal>
                <Eyebrow className="mb-4">Pricing</Eyebrow>
                <h1 className="font-display font-black uppercase text-brand-cream text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-[0.92] mb-6">
                    The spec sheet. <span className="text-brand-amber">No games.</span>
                </h1>
                <p className="text-brand-sage text-base sm:text-lg leading-relaxed max-w-2xl mb-12">
                    Every price we charge is on this page — the stump size
                    table, the difficulty add-ons, and the cleanup options.
                    Estimate yours below, then lock in the same week.
                </p>
            </Reveal>
            <Estimator />
        </section>

        <section className="pb-24">
            <PricingTables />
        </section>

        <CTASection testid="pricing-cta-section" />
    </main>
);

export default Pricing;
